<template>
  <div class="main-content">
    <div style="width: 50%; height: 600px">
      <div id="map" style="width: 100%; height: 600px"></div>
    </div>
    <div style="z-index: 999"><Table :tableList="tableList" /></div>
  </div>
</template>

<script>
import * as echarts from "echarts"; // 导入echarts库
import chinaJson from "./china.json";
import { countProvince, countCity } from "@/api/home/data";
import Table from "./table";

export default {
  components: {
    Table,
  },
  data() {
    return {
      mapList: [],
      tableList: [],
    };
  },
  async mounted() {
    await this.getMap();
  },
  methods: {
    //获取地图数据
    getMap() {
      countProvince()
        .then((res) => {
          if (res.code == 200) {
            if (res.data && res.data.length) {
              let newData = [...res.data];
              newData.shift();
              // return console.log(newData,'res.data.shift()res.data.shift()');
              this.mapList = newData.map((item) => {
                return {
                  ...item,
                  value: item.deviceNum,
                  // name: "陕西",
                  name: item.province.replace(
                    new RegExp(
                      "省|市|自治区|壮族自治区|回族自治区|维吾尔自治区|特别行政区",
                      "g"
                    ),
                    ""
                  ),
                };
              });
              console.log(this.mapList, "this.mapListthis.mapList");
              // this.tableList = [{
              //   ...res.data[0],
              //   city:res.data[0].province
              // }];
              this.tableList = res.data.map((item) => {
                return {
                  ...item,
                  city: item.province,
                };
              });
              // console.log(this.mapList, "res.data.shift()res.data.shift()");
            }
          }
        })
        .finally(() => {
          this.initChart(); // 初始化地图
        });
    },
    //获取表格数据
    getTable(e) {
      countCity({ province: e }).then((res) => {
        if (res.code == 200) {
          this.tableList = res.data;
        }
      });
    },
    initChart() {
      const chart = echarts.init(document.getElementById("map")); // 获取DOM元素

      // 设置地图参数及样式
      const option = {
        tooltip: {
          trigger: "item",
          formatter(item) {
            // console.log("item", item);
            return `
                <div style="color:#fff;display: flex;flex-flow: row nowrap;align-items: center;padding:10px;border-top:1px solid rgba(255,255,255,.2)">
                  <div style="width:10px;height:10px;border-radius:10px;margin-right:10px"></div>
                  <div>
                   <p style="color:#fff;">总设备数：${item.value || 0}</p>
                    <p style="color:#fff;">在线设备：${
                      item.data ? item.data.onlineNum : 0
                    }</p>
                    <p style="color:#fff;">离线设备：${
                      item.data ? item.data.offlineNum : 0
                    }</p>
                     <p style="color:#fff;">故障设备：${
                       item.data ? item.data.faultNum : 0
                     }</p>
                  </div>
                </div>
              `;
          },
        },
        series: [
          {
            type: "map",
            mapType: "china",
            roam: true,
            label: {
              show: true,
              // formatter: "132",
              formatter: function(params) {
                let str = "";
                if (params.value >= 1) {
                  str = "{b|" + params.name + "}";
                } else {
                  str = "{a|" + params.name + "}";
                }
                return str;
              },
              fontSize: 16,
              rich: {
                a: {
                  color: "#717888",
                },
                b: {
                  color: "#1ECF9C",
                },
              },
              // normal: {
              //   show: true,
              //   color: "#717888", // 省份名称颜色设置为红色
              // },
            },

            itemStyle: {
              normal: {
                // areaColor: 'rgba(24, 109, 212,0.7)',
                color: function(params) {
                  if (params.value >= 1) {
                    return "#defff5";
                  }
                },
                // 板块边框颜色
                borderColor: "#BCD4E6",
                areaColor: "#f3f6f9", // 设置地图背景色
              },
              emphasis: {
                // 鼠标悬浮在板块上的颜色
                areaColor: "#19F1B2",
              },
            },

            data: this.mapList,
          },
        ],
        // visualMap: {
        //   //视觉映射
        //   type: "piecewise", //分段
        //   pieces: [
        //     //块<!--min~max区间值----label显示的字段（标题）color:展示的颜色-->
        //     { min: 0, max: 0, label: "0", color: "#fff" },
        //     { min: 1, max: 9, label: "1-9", color: "#ffe4da" },
        //     { min: 10, max: 99, label: "10-99", color: "#ff937f" },
        //     { min: 100, max: 999, label: "100-999", color: "#ff6c5e" },
        //     { min: 1000, max: 9999, label: "1000-9999", color: "#fe3335" },
        //     { min: 10000, label: "≥10000", color: "#cd0000" },
        //   ],
        // },
      };

      // 加载地图数据
      echarts.registerMap("china", chinaJson); // 引入中国地图JSON文件

      // 添加事件处理函数
      chart.on("click", (params) => {
        if (params && params.name === "provinceName") {
          // provinceName为省份名字
          // 根据省份名字查询相关配件数量
          // TODO: 发送API请求获取相关配件数量信息
        }
        let newName = "";
        if (
          params.name == "上海" ||
          params.name == "北京" ||
          params.name == "天津" ||
          params.name == "重庆"
        ) {
          newName = params.name + "市";
        } else if (params.name == "内蒙古" || params.name == "西藏") {
          newName = params.name + "自治区";
        } else if (params.name == "广西") {
          newName = params.name + "壮族自治区";
        } else if (params.name == "宁夏") {
          newName = params.name + "回族自治区";
        } else if (params.name == "新疆") {
          newName = params.name + "维吾尔自治区";
        } else if (params.name == "香港" || params.name == "澳门") {
          newName = params.name + "特别行政区";
        } else {
          newName = params.name + "省";
        }
        this.getTable(newName);
      });

      // 将option应用到chart上
      chart.setOption(option);
    },
  },
};
</script>
<style scoped>
.main-content {
  display: flex;
}
.main-content > div {
  flex-basis: 50%;
  flex-grow: 0;
  flex-shrink: 0;
}
/* #map {
  width: 500px !important;
  height: 400px;
} */
</style>
